import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { ArrayChecker, Container, Pagination } from '../../../components';
import { QueryChips } from '../../../components/chip';
import { SystemProvider } from '../../system/provider';
import CollectionNav from './collection-nav';
import MobileLayout from "./page-mobile-layout"
import qs from 'query-string';
import PaginationInfo from '../../../components/dashboard-listing/list-filter-pagination-info';
import { List as ListOrganization } from '../../../pages/organization/components';
import adapterOrganization from '../../organization/adapter';
import { List as ListProgram } from '../../../pages/program/components';
import adapterProgram from '../../program/adapter';
import { List as ListEvent } from '../../../pages/event/components';
import adapterEvent from '../../event/adapter';
import { List as ListResource } from '../../../pages/resource/components';
import adapterResource from '../../resource/adapter';
import { List as ListBlog } from '../../../pages/blog/components';
import adapterBlog from '../../blog/adapter';

const ITEMS_PER_PAGE = 4

const PageResultMobile = ({onSort, customNav, filterOptions}) => {
  const { pathname, search } = useLocation()
  const history = useHistory()
  const data = useSelector(state => state.search.queryResults.results)
  const { totalResults, collection } = useSelector(state => state.search)
  const [pageIndexes, setPageIndexes] = useState(0, ITEMS_PER_PAGE)
  const query = qs.parse(search)

  useEffect(() => {
    setPageIndexes([0, ITEMS_PER_PAGE])
  }, [collection])

  const handlePaginationChange = (newPage) => {
    const limit = ITEMS_PER_PAGE
    const offset = limit*(newPage-1)

    const newQuery = {
      ...query,
      limit,
      offset
    }

    // Set pagination info
    const startIndex = (newPage-1)*ITEMS_PER_PAGE
    const endIndex = startIndex + ITEMS_PER_PAGE
    setPageIndexes([startIndex, endIndex])

    history.push({
      pathname,
      search: qs.stringify(newQuery)
    })
  }

  return (
    <MobileLayout onSort={onSort} filterOptions={filterOptions}>
      {
        customNav ? customNav : <CollectionNav />
      }

      <Container className="mb-4 text-sm">
        <PaginationInfo
          currentPageStart={pageIndexes[0]+1}
          currentPageEnd={pageIndexes[1] > totalResults ? totalResults : pageIndexes[1]}
          totalData={totalResults}
        />
      </Container>

      <SystemProvider>
        <div className="mb-8">
          <QueryChips />
        </div>
      </SystemProvider>

      <Container>
        <ArrayChecker data={data}>
          <>
            {
              collection === 'organizations' &&
              <ListOrganization data={data?.map(d => adapterOrganization.responseBodyToRender(d))}/>
              // <DevLogger data={data?.map(d => d.organisasiId)}/>
            }
            {
              collection === 'programs' &&
              <ListProgram data={data?.map(d => adapterProgram.responseBodyToRender(d))}/>
            }
            {
              collection === 'events' &&
              <ListEvent data={data?.map(d => adapterEvent.responseBodyToRender(d))}/>
            }
            {
              collection === 'resources' &&
              <ListResource data={data?.map(d => adapterResource.responseBodyToRender(d))}/>
            }
            {
              collection === 'blogs' &&
              <ListBlog data={data?.map(d => adapterBlog.responseBodyToRender(d))}/>
            }
          </>
        </ArrayChecker>

        <Pagination
          itemsPerPage={ITEMS_PER_PAGE}
          totalItems={totalResults}
          defaultCurrentPage={1}
          onChange={handlePaginationChange}
        />
      </Container>
    </MobileLayout>
  )
}

export default PageResultMobile
